module.exports = __webpack_public_path__ + "iconfont.ttf?65b99bfa02c0bd59f8d6e1900e047d27";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/iconfont.ttf?t=1534686008312
// module id = 128
// module chunks = 0